import request from "@/util/http";
import qs from "qs"; // 主题列表查询

export var getSubjectList = function getSubjectList(params) {
  return request({
    url: "/admin/subject/page",
    method: "get",
    params: params
  });
}; // 主题单个删除

export var handleSubjectDelete = function handleSubjectDelete(id) {
  return request({
    url: "/admin/subject/delete/".concat(id),
    method: "delete"
  });
}; // 主题信息

export var getSubjectInfo = function getSubjectInfo(id) {
  return request({
    url: "/admin/subject/get/".concat(id),
    method: "get"
  });
}; // 保存主题

export var hallSaveOrUpdate = function hallSaveOrUpdate(data) {
  return request({
    url: "/admin/subject/saveOrUpdate",
    method: "post",
    data: qs.stringify(data)
  });
};